module.exports = __webpack_public_path__ + "static/media/img_09.2bb23781.jpg";